<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 0px;
  min-height: 100%;

  display: flex;
  width: 100%;
  position: absolute;
  flex-direction: column;
  justify-content: space-between;
}
html {
  height: 100%;
}

body {
  min-height: 100%;
  position: relative;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue